'use strict';
(function ($) {
	$("document").ready(function () {
		$('.stop-animation-js').on('click', function(e){
			e.preventDefault();
			$('body').toggleClass('stop-animation-js-active');
			if (localStorage.getItem('stop-animation-js-active')) {
				localStorage.removeItem('stop-animation-js-active');
				//revapi1.revresume();
				setTimeout(function(){
					$('#carousel').carousel('cycle');
					$('.carousel').carousel('cycle');
				},1000)
			} else {
				localStorage.setItem('stop-animation-js-active', true);
				//revapi1.revpause();
				setTimeout(function(){
					$('#carousel').carousel('pause');
					$('.carousel').carousel('pause');
				},1000)
			}
		});
		function change_stop_play() {
			let get_change_stop_play = localStorage.getItem("stop-animation-js-active");
			if (get_change_stop_play) {
				$("body").toggleClass("stop-animation-js-active");
				setTimeout(function(){
					$('#carousel').carousel('pause');
					$('.carousel').carousel('pause');
				},1000)
			}
		}
		change_stop_play();
	});
})(jQuery);
